<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          v-if="mode == 0 && (bank == null || bank.bankId == -1)"
          class="mr-1"
          small
          color="primary"
          v-on="tooltip"
          dark
          @click="chooseBank"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-else
          class="mr-1"
          small
          color="primary"
          dark
          v-on="{ ...tooltip }"
          v-on:click="() => (dialog = !dialog)"
        >
          <v-icon>{{
            `${mode === 0 ? "mdi-plus" : "mdi-pencil-outline"}`
          }}</v-icon>
        </v-btn>
      </template>
      <span>{{
        `${
          mode === 0
            ? $t("referenceBooks.users.Create")
            : $t("referenceBooks.users.Edit")
        }`
      }}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <v-card width="500px">
        <v-card-title>
          <span class="headline">{{
            `${
              mode === 0
                ? $t("referenceBooks.users.Create")
                : $t("referenceBooks.users.Edit")
            }`
          }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  :label="$t('referenceBooks.users.BankName') + '*'"
                  disabled
                  v-model="currentUser.bankId"
                  :key="'bankId'"
                  :item-value="'bankId'"
                  :item-text="'bankName'"
                  :items="banks"
                  required
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  :label="$t('referenceBooks.users.BranchName') + '*'"
                  disabled
                  v-model="currentUser.branchId"
                  :key="'branchId'"
                  :item-value="'branchId'"
                  :item-text="'name'"
                  :items="branches"
                  required
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="currentUser.name"
                  :label="$t('referenceBooks.users.UserName') + '*'"
                  required
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="currentUser.description"
                  :label="$t('referenceBooks.users.Description') + '*'"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">{{
            $t("Close")
          }}</v-btn>
          <v-btn color="blue darken-1" text v-if="mode === 0" @click="create">{{
            $t("Create")
          }}</v-btn>
          <v-btn color="blue darken-1" text v-else @click="save">{{
            $t("Save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import { notifySuccess, notifyError } from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';
export default {
  components: {
    DragForm,
  },
  name: 'UserDialog',
  props: {
    mode: {
      defaultItem: 0,
    },
    userId: {
      defaultItem: 0,
    },
    bank: {
      type: Object,
      default: null,
    },
    branch: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentUser: {},
      banks: [],
      branches: [],
      dialog: false,
    };
  },

  watch: {
    dialog(val) {
      if (val) {
        if (this.mode === 1) {
          this.banks = [
            {
              bankId: this.userId.bankId,
              bankName: this.userId.bankName,
            },
          ];
          this.currentUser.bankId = this.userId.bankId;

          if (this.userId.branchId !== 0) {
            this.branches = [
              {
                branchId: this.userId.branchId,
                name: this.userId.branchName,
              },
            ];
            this.currentUser.branchId = this.userId.branchId;
          }

          this.currentUser.name = this.userId.name;
          this.currentUser.description = this.userId.description;
        } else if (this.mode === 0) {
          this.banks = [this.bank];
          this.currentUser.bankId = this.bank.bankId;

          if (!(this.branch == null || this.branch.branchId == -1)) {
            this.branches = [this.branch];
            this.currentUser.branchId = this.branch.branchId;
          }
        }
      } else {
        this.$emit('rerender');
        this.banks = [];
        this.branches = [];
        this.currentUser = {};
      }
    },
  },
  methods: {
    chooseBank() {
      notifyError('', this.$t('referenceBooks.banks.ChooseSomeBank'));
    },
    save() {
      this.$axios.users
        .putById(this.userId.userId, this.currentUser)
        .then(() => {
          notifySuccess(
            '',
            this.$t('Messages.UserWasEdited', [this.currentUser.name])
          );
          this.$emit('updated', this.currentUser.userId);
          this.dialog = false;
        })
        .catch((error) => {
          console.error(error);
          notifyError(
            '',
            this.$t('Messages.ErrorOccuredWhileEditingUser', [
              this.currentUser.name,
            ])
          );
        });
    },
    create() {
      this.$axios.users
        .post(this.currentUser)
        .then((response) => {
          const userId = response.data;
          notifySuccess(
            '',
            this.$t('Messages.UserWasCreated', [this.currentUser.name])
          );
          this.$emit('created', userId);
          this.dialog = false;
        })
        .catch((error) => {
          notifyError(
            '',
            this.$t('Messages.ErrorOccuredWhileCreatingUser', [
              this.currentUser.name,
            ])
          );

          console.error(error);
        });
    },
  },
};
</script>
